export default "__VITE_ASSET__CCVWP1bC__"